import "./ackStyles.scss";
import nsfLogo from "../../../assets/nationalScienceFoundationLogo.png"

const AcknowledgementsSection = () => {
  return (
    <section className="acknowledgements-section">
      <div className="contactUsContainer">Contact us <a target="_blank" href="mailto:srayat@bsu.edu">here</a> (iascend@bsu.edu) with any questions</div>

      <div className="content-wrapper">

        <div>
          <h1>Acknowledgements</h1>
          <p>
            This material is based upon work supported by the National Science
            Foundation under <br /> Grant No. 2211149. Any opinions, findings, and
            conclusions or recommendations <br /> expressed in this material are
            those of the author(s) and do not necessarily reflect the <br /> views
            of the National Science Foundation.
          </p>
        </div>

        <img src={nsfLogo}></img>
        
      </div>

    </section>
  );
};

export default AcknowledgementsSection;
